var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFan1 = function SvgFan1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 13
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fan1_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4697",
    transform: "translate(17 -480.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1066",
    width: 30,
    height: 13,
    rx: 3,
    transform: "translate(-17 480.904)",
    opacity: 0.8,
    fill: "url(#Fan1_svg__a)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-13 489.904)",
    fontSize: 7,
    fontFamily: "Roboto-Bold,Roboto",
    fontWeight: 700,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FAN")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4407"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 100",
    d: "M6.935 491.254H4.757l1.2-6.016H4.526l.341-1.683h3.607l-1.54 7.7z",
    fill: "#fff"
  })))));
};
export default SvgFan1;